import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Input, Phrase, Row, Spacer } from "@neru/ui";
export var SearchInput = function(param) {
    var _param_initFormElements = param.initFormElements, initFormElements = _param_initFormElements === void 0 ? function(x) {
        return x;
    } : _param_initFormElements, name = param.name, onClear = param.onClear, _param_placeholder = param.placeholder, placeholder = _param_placeholder === void 0 ? "Search" : _param_placeholder, _param_showHint = param.showHint, showHint = _param_showHint === void 0 ? false : _param_showHint, value = param.value;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: initFormElements(/*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Input, {
                    "data-testid": "search-input",
                    icon: "search-line",
                    name: name,
                    onClear: onClear,
                    placeholder: placeholder,
                    type: "search",
                    value: value,
                    withClearButton: Boolean(onClear)
                }),
                showHint && /*#__PURE__*/ _jsxs(Row, {
                    className: "justify-end",
                    children: [
                        /*#__PURE__*/ _jsxs(Phrase, {
                            className: "\n                text-primary-500 mt-1 text-sm\n                dark:text-primary-500\n              ",
                            children: [
                                "Press ",
                                /*#__PURE__*/ _jsx("strong", {
                                    children: "Enter ↵"
                                }),
                                " to search"
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "xl"
                        })
                    ]
                })
            ]
        }))
    });
};

//# sourceMappingURL=SearchInput.js.map